import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";
import { db } from "../index";

function useRandomCity() {
	const [city, setCity] = useState("");
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	const loadCity = useCallback(async () => {
		setLoading(true);
		try {
			const cities_query = query(
				collection(db, "meetups"),
				orderBy("address", "desc"),
				limit(50)
			);

			const cities = [];
			const loadCities = await getDocs(cities_query);
			loadCities.forEach((city) =>
				cities.push({
					id: city.id,
					...city.data(),
				})
			);
			if (cities.length === 0){
				throw new Error("Unable to find a city - incorrect number of results");
			}

			//set city
			const randomCity = cities[(Math.ceil(Math.random() * cities.length))];
			setCity(randomCity);

		} catch (error) {
			console.error(error);
			setError(error);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		loadCity();
		
	}, [loadCity]);

	
	return [loading, error, city,  loadCity];

}
export default useRandomCity;
